var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 60 6.828125 L 57.171875 4 L 4 57.171875 L 6.828125 60 L 10.828125 56 L 52 56 C 54.207031 55.996094 55.996094 54.207031 56 52 L 56 10.828125 Z M 52 52 L 14.828125 52 L 30.414062 36.414062 L 35.171875 41.171875 C 36.734375 42.734375 39.265625 42.734375 40.828125 41.171875 L 44 38 L 52 45.996094 Z M 52 40.335938 L 46.828125 35.164062 C 45.265625 33.601562 42.734375 33.601562 41.171875 35.164062 L 38 38.335938 L 33.246094 33.582031 L 52 14.828125 Z M 52 40.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 12 44 L 12 38 L 22 28.007812 L 24.746094 30.753906 L 27.578125 27.921875 L 24.828125 25.171875 C 23.265625 23.609375 20.734375 23.609375 19.171875 25.171875 L 12 32.34375 L 12 12 L 44 12 L 44 8 L 12 8 C 9.792969 8.003906 8.003906 9.792969 8 12 L 8 44 Z M 12 44 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.e696c276a62c5119a0645254e21f357e.svg";
export { ForwardRef as ReactComponent };